export default [
    {
        url: '/overview',
        name: 'Overview',
        icon: 'cloud_queue'
    },
    {
        url: '/report',
        name: 'Report',
        icon: 'description'
    },
    {
        url: '/map',
        name: 'Map',
        icon: 'map'
    },
    {
        url: '/dashboard',
        name: 'Dashboard',
        icon: 'dashboard'
    },
    {
        url: '/customdashboard',
        name: 'Custom Dashboard',
        icon: 'dashboard'
    },
    {
        url: '/location',
        name: 'Location',
        icon: 'room'
    },
    {
        url: '/indoortracking',
        name: 'Indoor Tracking',
        icon: 'compass_calibration'
    },
    {
        url: '/sensor',
        name: 'Device',
        icon: 'signal_cellular_alt'
    },
    {
        url: '/gateway',
        name: 'Gateway',
        icon: 'router'
    },
    {
        url: '/Alert',
        name: 'Alert',
        icon: 'report_problem'
    },
    // {
    //     url: "/camera",
    //     name: "Camera",
    //     icon: "photo_camera"
    // },

    {
        url: '/workorder',
        name: 'Work Management',
        icon: 'work'
    },
    {
        url: '/WorkRequests',
        name: 'Work Request',
        icon: 'work' //10
    },
    {
        url: '/parts',
        name: 'Parts',
        icon: 'settings'
    },
    // {
    // 	url: "/workstatus",
    // 	name: "Work Status",
    // 	icon: "assignment"
    // },
    {
        url: '/action',
        name: 'Alert Setting',
        icon: 'new_releases'
    },
    {
        url: '/network',
        name: 'Network',
        icon: 'wifi'
    },
    {
        url: '/user',
        name: 'User',
        icon: 'person'
    },
    {
        url: '/locationsetting',
        name: 'Location Setting',
        icon: 'explore'
    },
    // {
    //     url: '/permission',
    //     name: 'Permission Setting',
    //     icon: 'how_to_reg'
    // },
    // {
    // 	url: "/setting",
    // 	name: "Setting",
    // 	icon: "settings"
    // },
    // {
    //     url: '/form',
    //     name: 'Form',
    //     icon: 'insert_drive_file'
    // },
    {
        url: '/SetupWorkRequests',
        name: 'Setup Work Requests',
        icon: 'work'
    },
    // {
    //     url: '/mailbox',
    //     name: 'Mailbox',
    //     icon: 'mail'
    // },
    {
        url: '/IndoorOverview',
        name: 'Overview',
        icon: 'cloud_queue'
    },
    {
        url: '/IndoorReport',
        name: 'Report',
        icon: 'new_releases'
    },
    {
        url: '/IndoorDashboard',
        name: 'Dashboard',
        icon: 'dashboard' //20
    },

    {
        url: '/IndoorTag',
        name: 'Tag',
        icon: 'loyalty' //21
    },
    {
        url: '/IndoorEsset',
        name: 'Asset',
        icon: 'settings_remote'
    },
    {
        url: '/IndoorSensor',
        name: 'Sensor',
        icon: 'contactless'
    },
    {
        url: '/IndoorGateway',
        name: 'Gateway',
        icon: 'router'
    },
    {
        url: '/IndoorAlert',
        name: 'Alert',
        icon: 'report_problem'
    },
    {
        url: '/IndoorAlertSetting',
        name: 'Alert Setting',
        icon: 'new_releases'
    },
    {
        url: '/kubotafarm',
        name: 'kubotafarm',
        icon: 'new_releases'
    }, {
        url: '/locationdashboard',
        name: 'locationdashboard',
        icon: 'new_releases'
    }, {
        url: '/KPCool',
        name: 'KPCool',
        icon: 'new_releases'
    }, {
        url: '/Stock-DashBoard',
        name: 'Stock-DashBoard',
        icon: 'new_releases'
    }, {
        url: '/StockAlert',
        name: 'StockAlert',
        icon: 'report_problem'
    },{
        url: '/v-steel',
        name: 'v-steel',
        icon: 'report_problem'
    },{
        url: '/v-steel-gif-off',
        name: 'v-steel-gif-off',
        icon: 'report_problem'
    },{
        url: '/I-APC',
        name: 'I-APC',
        icon: 'report_problem'
    },{
        url: '/I-APC-RM',
        name: 'I-APC-RM',
    }, {
        url: '/aqidashboard',
        name: 'aqidashboard',
        icon: 'report_problem'
    },


]